import { useCallback, useEffect, useRef } from 'react';
import AuthService from './service';

export default function useSsoDetection(onSsoDetected) {
    const timerRef = useRef(null);
    const serviceRef = useRef(null);
    const latestEmailRef = useRef('');
    if (!serviceRef.current) serviceRef.current = new AuthService();

    useEffect(() => () => timerRef.current && clearTimeout(timerRef.current), []);

    return useCallback(
        email => {
            if (timerRef.current) clearTimeout(timerRef.current);
            latestEmailRef.current = email;
            if (!email) return;
            timerRef.current = setTimeout(() => {
                serviceRef.current.checkForSSO(email).then(response => {
                    if (response && response.value && email === latestEmailRef.current) onSsoDetected();
                });
            }, 300);
        },
        [onSsoDetected]
    );
}
